// Fetch a presigned S3 URL as a Blob.
//
// MUST bypass the app's axios layer: the trial-expiration response interceptor
// lives on the DEFAULT axios instance (helpers/requests.js), and the Clerk
// bearer must never be sent cross-origin to S3. A bare `fetch` (no credentials,
// no custom headers) avoids both — the presigned URL is self-authenticating.
export async function fetchPresignedBlob(url) {
  const res = await fetch(url, { credentials: 'omit' });
  if (!res.ok) throw new Error(`Presigned fetch failed: ${res.status}`);
  return res.blob();
}

export default fetchPresignedBlob;
